// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__2OMTd","switchInactive":"Switch_switchInactive__3zDwo","switchActive":"Switch_switchActive__2nR4k"};